import React from 'react';
import { useAuth  } from '../../Context/AuthContext';
import { Link } from 'react-router-dom';

const AdminDashboard: React.FC = () => {
  const { user } = useAuth();
  
  return (
    <div className="container py-5">
    </div>
  );
};

export default AdminDashboard;